import { CustomersTable } from "@src/components/tables";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Button, Loader, Modal, TabSelector } from "@src/components/atoms";
import { useAdminContext } from "@src/context/adminContext";
import { CustomerForm } from "@src/components/forms/admin/CustomerForm";
import { useLocation, useParams } from "react-router-dom";
import { CharityForm } from "@src/components/forms/admin/CharityForm";
import { CharitiesSection } from "./CharitiesSection";
import { MainDetailsSection } from "./MainDetailsSection";
import { TeamsSection } from "./TeamsSection";
import { BehavioursSection } from "../shared/BehavioursSection";
import { CustomerBehaviourGroupsSection } from "../shared/CustomerBehaviourGroupsSection";
import { UsersSection } from "../shared/UsersSection";
import { CustomerLogosSection } from "./CustomerLogosSection";

const tabOptions = [
  { key: "main", label: "Main" },
  { key: "charities", label: "Charities" },
  { key: "behaviours", label: "Behaviours" },
  { key: "behaviourGroups", label: "Behaviour Groups" },
  { key: "teams", label: "Teams" },
  { key: "users", label: "Users" },
  { key: "logos", label: "Logos" },
];
const CustomerDetailsPage = () => {
  const admin = useAdminContext();
  const { customers } = admin;
  const [isEditing, setIsEditing] = useState(false);
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(
    location?.state?.tab || tabOptions[0],
  );

  const { customerId } = useParams();
  const [selectedCustomer, setSelectedCustomer] = useState(
    customers.filter(
      (c) => c.id === customerId || c.customerCode === customerId,
    )?.[0] || null,
  );

  if (!selectedCustomer) return <Loader />;

  return (
    <>
      <h3 className="flex flex-col text-center p-4">Customer details</h3>
      <div className="flex justify-between items-center">
        <div className="p-4">
          <h4 className="mb-0">
            {selectedCustomer.name} ({selectedCustomer.customerCode})
          </h4>
        </div>
        <TabSelector
          selected={selectedTab}
          options={tabOptions}
          onClick={setSelectedTab}
        />
      </div>
      {selectedTab === "main" && <MainDetailsSection data={selectedCustomer} />}
      {selectedTab === "charities" && (
        <CharitiesSection
          data={selectedCustomer?.charities}
          customer={selectedCustomer}
        />
      )}
      {selectedTab === "teams" && (
        <TeamsSection
          customerId={selectedCustomer?.id}
          customerCode={selectedCustomer?.customerCode}
          industry={selectedCustomer?.industry}
        />
      )}
      {selectedTab === "behaviours" && (
        <BehavioursSection
          customerId={selectedCustomer?.id}
          customerCode={selectedCustomer?.customerCode}
          industry={selectedCustomer?.industry}
        />
      )}
      {selectedTab === "behaviourGroups" && (
        <CustomerBehaviourGroupsSection customerId={selectedCustomer?.id} />
      )}
      {selectedTab === "users" && (
        <UsersSection customerCode={selectedCustomer?.customerCode} />
      )}
      {selectedTab === "logos" && (
        <CustomerLogosSection customer={selectedCustomer} />
      )}
    </>
  );
};

export default CustomerDetailsPage;
